import React from "react";
import { FaClipboardList } from "react-icons/fa";
import { useSelector } from "react-redux";
import styles from "../../../../../src/pages/schoolCockpit/master/academicConfiguration/Academiclist.module.css";
import { CustomTab } from "../../../../components";
import AllLessonPlan from "./AllLessonPlan";
import SubmittedLessonPlan from "./SubmittedLessonPlan";
import ApprovedLessonPlan from "./ApprovedLessonPlan";
import RejectedLessonPlan from "./RejectedLessonPlan";
import PreviousYearsLessonPlan from "./Previousyearslessonplan";

function LessonPlanList() {
  const { translations } = useSelector((state) => state.language);
  // const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      label: translations?.labels?.tabAll || "All",
      content: <AllLessonPlan />,
    },
    {
      label: translations?.labels?.tabSubmitted || "Submitted",
      content: <SubmittedLessonPlan />,
    },
    {
      label: translations?.labels?.tabApproved || "Approved",
      content: <ApprovedLessonPlan />,
    },
    {
      label: translations?.labels?.tabRejected || "Rejected",
      content: <RejectedLessonPlan />,
    },
    {
      label:
        translations?.labels?.tabPreviousYears ||
        "Previous Years Lesson Plans",
      content: <PreviousYearsLessonPlan />,
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerIcon}>
          <FaClipboardList />
        </div>
        <h1 className={styles.headerTitle}>
          {translations?.labels?.lessonPlan || "Lesson Plan"}
        </h1>
      </div>

      <CustomTab
        tabs={tabs}
        defaultActiveTab={0}
        // onTabChange={(i) => setActiveTab(i)}
      />
    </div>
  );
}

export default LessonPlanList;